import { render, staticRenderFns } from "./publication-card.vue?vue&type=template&id=58c556e0&scoped=true&"
import script from "./publication-card.vue?vue&type=script&lang=js&"
export * from "./publication-card.vue?vue&type=script&lang=js&"
import style0 from "./publication-card.vue?vue&type=style&index=0&id=58c556e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c556e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle})
